module.exports = __webpack_public_path__ + "assets/img/tjjl.a4bcab6b.png";